'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var APP_BLOCKED_SET = exports.APP_BLOCKED_SET = 'APP_BLOCKED_SET';
var APP_BOT_PROJECT_ID_SET = exports.APP_BOT_PROJECT_ID_SET = 'APP_BOT_PROJECT_SET';
var APP_CHAT_IN_PROGRESS_ELSEWHERE = exports.APP_CHAT_IN_PROGRESS_ELSEWHERE = 'APP_CHAT_IN_PROGRESS_ELSEWHERE';
var APP_DIALOGFLOW_SET = exports.APP_DIALOGFLOW_SET = 'APP_DIALOGFLOW_SET';
var APP_SCROLLED_SET = exports.APP_SCROLLED_SET = 'APP_SCROLLED_SET';

var CONVERSATION_CLEAR = exports.CONVERSATION_CLEAR = 'CONVERSATION_CLEAR';
var CONVERSATION_SET = exports.CONVERSATION_SET = 'CONVERSATION_SET';
var CONVERSATION_PROCESSING_SET = exports.CONVERSATION_PROCESSING_SET = 'CONVERSATION_PROCESSING_SET';
var CONVERSATION_QUEUE_CLEAR = exports.CONVERSATION_QUEUE_CLEAR = 'CONVERSATION_QUEUE_CLEAR';
var CONVERSATION_QUEUE_SET = exports.CONVERSATION_QUEUE_SET = 'CONVERSATION_QUEUE_SET';